// @flow
import type { Action } from '../actions/types';
import { TOGGLE_TIPS } from '../actions/types';

export type TipsState = {|
	state: boolean,
|};

const initialState: TipsState = {
	state: false,
};

export const tipsReducer = (state: TipsState = initialState, action: Action) => {
	const { type, payload } = action;
	switch (type) {
		case TOGGLE_TIPS:
			return {
				state: payload
			};

		default:
			return state;
	}
};
